export default {
  namespaced: true,
  state() {
    return {
      showErrorLogin: false,
      message: '',
      showRecoverySuccess: false,
    }
  },
  mutations: {
    SHOW_ERROR_LOGIN(state,data) {
      state.showErrorLogin = data
    },
    SET_MESSAGE(state,data) {
      state.message = data
    },
    SET_RECOVERY_SUCCESS(state,data) {
      state.showRecoverySuccess = data
    }
  }
}
